Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness'

class Monitoring.Models.SocialContents.GoogleMyBusiness.GoogleMyBusinessLocationSummary
  constructor: (builder) ->
    @name = builder.getName()
    @locationName = builder.getLocationName()
    @url = builder.getURL()
    @storeCode = builder.getStoreCode()
    @address = builder.getAddress()

  getName: =>
    @name

  getLocationName: =>
    @locationName

  getURL: =>
    @url

  getStoreCode: =>
    @storeCode

  getAddress: =>
    @address
